import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1);
   const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendOtp = async () => {
    try {
      const { data: result } = await apiClient.post(`${SERVER_BASE}/check-email`, { email });

      if (!result.success) {
        setLoading(true)
        await apiClient.post(`${SERVER_BASE}/send-otp`, { email });
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `OTP sent to ${email}. Please check your inbox/spam.`,
          showConfirmButton: false,
          timer: 7000,
          timerProgressBar: true,
        }).then(() =>{setLoading(false) 
        setStep(2)});
      } else {
        setLoading(false)
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Email not found.',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
        setLoading(false)
      Swal.fire('Error', 'Failed to check email. Try again.', 'error');
    }
  };

  const verifyOtp = async () => {
    try {
      const { data: result } = await apiClient.post(`${SERVER_BASE}/verify-otp`, { email, otp });
      if (result.success) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'OTP Verified!',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
            setLoading(true)
            setStep(3)});
      } else {
         setLoading(false)
        Swal.fire('Error', 'Invalid OTP. Please try again.', 'error');
      }
    } catch (error) {
         setLoading(false)
      Swal.fire('Error', 'Verification failed. Please try again.', 'error');
    }
  };

  const updatePassword = async () => {
    try {
      const response = await apiClient.post(`${SERVER_BASE}/update-password`, {
        email,
        password: newPassword,
      });
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: response.data.message || 'Password updated successfully!',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).then(() => navigate('/'));
    } catch (error) {
      Swal.fire('Error', 'Failed to update password. Try again.', 'error');
    }
  };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="card shadow-lg p-4" style={{ maxWidth: '500px', width: '100%' }}>
        <h3 className="text-center mb-4 ">Forgot Password</h3>

        {step === 1 && (
          <>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your registered email"
              />
            </div>
            <button
              type="button"
              className="btn btn-success w-100"
              disabled={loading}
              onClick={sendOtp}
            >
              {loading?'Sending...':'Send OTP'}
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <div className="mb-3">
              <label htmlFor="otp" className="form-label">Enter OTP</label>
              <input
                type="text"
                className="form-control"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter the OTP sent to your email"
              />
            </div>
            <button
              type="button"
              className="btn btn-success w-100"
              onClick={verifyOtp}
              disabled={loading}
            >
            {loading?'Verifying...':'Verify OTP'}
            </button>
          </>
        )}

        {step === 3 && (
          <>
            <div className="mb-3">
              <label htmlFor="new-password" className="form-label">New Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  id="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter your new password"
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={toggleShowPassword}
                  tabIndex={-1}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>
            <button
              type="button"
              className="btn btn-success w-100"
              onClick={updatePassword}
            >
              Update Password
            </button>
          </>
        )}

        <button
          className="btn btn-link mt-3 w-100 text-decoration-none"
          onClick={() => navigate('/')}
        >
          <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
